<div class="modal-header">
  <h4 class="modal-title">Send Information about the company</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeForm()">
    <i class="fa fa-times-circle"></i>
  </button>
</div>

<div class="modal-body">

  <form [formGroup]="sendInfoForm" #inviteBene="ngForm">
    <div class="modal-body">
      <div class="container">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>Company Name*</label>
            <select class="im-input" formControlName="company">
              <option class="im-input" *ngFor="let company of listCompany" [value]="company.id">
                {{company.companyName}}
              </option>
            </select>
            <span class="invalid-message"
              *ngIf="(sendInfoForm.get('company').touched ) && sendInfoForm.get('company').errors?.required">
              **Field is required
            </span>
          </div>
        </div>
        <hr />
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="d-block">How would you like to send the information to the recipients?*</label>
            <p-radioButton formControlName="sendInfoThroughEmailOrLink" value="EMAIL" label="Email">
            </p-radioButton>
            <p-radioButton class="ml-4" formControlName="sendInfoThroughEmailOrLink" value="LINK" label="Link">
            </p-radioButton>
            <span class="invalid-message"
              *ngIf="(sendInfoForm.get('sendInfoThroughEmailOrLink').touched) && sendInfoForm.get('sendInfoThroughEmailOrLink').errors?.required">
              **Field is required
            </span>
          </div>
        </div>

        <label class="text-secondary small" *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL'">Email
          option will send both Email & In-app notification</label>
        <label class="text-secondary small" *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'">Link option
          will send In-app notification. If you want to review through Email too, Please check 'Send Email to
          Recipient'.</label>

        <div class="border p-3 bg-light"
          *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL' || sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'">
          <label class="lead d-block" *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL'">Compose Email
            Content</label>
          <label class="lead d-block" *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'">Send URL</label>
          <label>Subject</label>
          <input class="form-control im-pt-3 pr-5" pInputText type="text" formControlName="subject">
          <label *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL'" class="d-block">Message</label>
          <label *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'">Enter URL</label>
          <!-- <textarea *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL'" [froalaEditor]="options"  -->
          <!-- [(froalaModel)]="bodyContent"></textarea> -->
          <kendo-editor *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'EMAIL'" [(ngModel)]="bodyContent"
            (valueChange)="valueChange($event)" #sendinvitekendoeditor>

            <kendo-toolbar>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
              <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
              <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
              <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
              <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>                                
              <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
              <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
              <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                <kendo-toolbar-button
                title="Upload’s Image at cursor point"
                text="Upload Image"
                (click)="sendinviteimageuploaddialog()"
                ></kendo-toolbar-button>
              </kendo-toolbar-buttongroup>                                  
            </kendo-toolbar>
          </kendo-editor>
          <app-upload-image-dialog #sendinviteimageupload [editor]="sendinvitekendoeditor">
          </app-upload-image-dialog>


          <input *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'" class="form-control im-pt-3 pr-5"
            pInputText type="text" formControlName="body">
        </div>
        <hr />
        <div class="form-row">
          <div class="form-group col-md-12">
            <label class="d-block">Add additional notes</label>
            <textarea class="im-input text-area" type="textarea" formControlName="additionalNote"></textarea>
          </div>
          <div *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'" class="mb-3">
            <p-checkbox formControlName="isEmailRequiredForLink" binary="true" inputId="isEmailRequired"></p-checkbox>
            <label class="ml-2 mb-0" for="isEmailRequired">Send Email to Recipient</label>
          </div>
        </div>
        <button *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink != 'LINK'" pButton type="submit" label="Send Info"
          [disabled]="!sendInfoForm.valid && bodyContent.length == 0" (click)="inviteExternalBeneFormSub()"></button>
        <button *ngIf="sendInfoForm.value.sendInfoThroughEmailOrLink == 'LINK'" pButton type="submit" label="Send Info"
          [disabled]="!sendInfoForm.valid" (click)="inviteExternalBeneFormSub()"></button>

      </div>

    </div>

  </form>
</div>